import React, { useEffect, useRef, useState } from "react";
import styles from "./WorkOrders.module.css";
import { List } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import { SearchInput } from "../../../components";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import WorkOrderRequestMiddleware from "../../../store/Middlewares/WorkOrderRequestMiddleware";
import moment from "moment";

function WorkOrders() {
  const navigate = useNavigate();
  const { state } = useLocation();

  useEffect(() => {
    getWorkOrderRequestCustomerId();
    getLanguage();
  }, []);

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [search, setSearch] = useState('')
  const timeout = useRef(null);
  const data = state;
  const WorkOrderRequestList = useSelector(state => state.WorkOrderRequestReducer.WorkOrderRequestList);
  console.log('WorkOrderRequestList',WorkOrderRequestList)
  console.log('data',data)
  const user = useSelector(state => state.AuthReducer.user);
  console.log('user', user)

  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language)
    } catch (e) {
      console.log(e)
    }
  };

  const getWorkOrderRequestCustomerId = () => {
    let userData = {
      search: search,
      id: data ? data?.id : user?.id
    }
    dispatch(WorkOrderRequestMiddleware.getWorkOrderRequestCustomerDetails(userData))
  }

  const onSearchWorkOrderRequestCustomers = text => {
    let userData = {
      search: text,
      id: data ? data?.id : user?.id
    };
    setSearch(text);
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      dispatch(
        WorkOrderRequestMiddleware.getWorkOrderRequestCustomerDetails(userData),
      );
    }, 1000);
  };



  const renderItem = (item) => {
    return (
      <div
        className={styles.location_item}
        onClick={() =>
          navigate("/WorkOrderRequest/WorkOrderDetail", {
            state: { data: item, customer_no: data?.contact_no },
          })
        }
      >
        <div className={styles.flex}>
          <div className={styles.heading_view}>
            <text className={styles.heading}>
              {t("Work Order")} {item?.request_no}
            </text>
            <text className={styles.span}>{moment(item?.date).format('MM-DD-YYYY')}</text>
          </div>
        </div>
        <IoIosArrowForward className={styles.icon} size={25} />
      </div>
    );
  };

  return (
    <div className={styles.home_mainContainer}>
      <h1 className={styles.main_heading}>{t("Work Order List")}</h1>

      <div className={styles.used_search_input}>
        <SearchInput
          placeholder={t("Search")}
          onChange={(e) => onSearchWorkOrderRequestCustomers(e.target.value)}
        />
      </div>
      <List dataSource={WorkOrderRequestList} renderItem={renderItem} />
    </div>
  );
}

export default WorkOrders;
